import { render, staticRenderFns } from "./Tablex.vue?vue&type=template&id=4deb2ca0&scoped=true&"
import script from "./Tablex.vue?vue&type=script&lang=js&"
export * from "./Tablex.vue?vue&type=script&lang=js&"
import style0 from "./Tablex.vue?vue&type=style&index=0&id=4deb2ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb2ca0",
  null
  
)

export default component.exports